import axios from 'axios';
const uuidv4 = require('uuidv4');
export default {
    data(){
        return {
            isUploadingInProgress: false,
            attachment_file:"",
            check_attachments: false
        }
    },
    methods: {
        uploadAttachment(newFile, oldFile) {
            var input = newFile;
            if (input.file) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuidv4,
                    name: input.file.name,
                    size: JSON.stringify(input.file.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.attachments.push(attachment);
                let type = attachment.name.split(".");
                if (type[1] == "jpg" || type[1] == "jpeg" || type[1] == "png" || type[1] == "svg") {
                    this.images.push(attachment);
                }else if (type[1] == "mpg" || type[1] == "mpeg" || type[1] == "mp4" || type[1] == "mp3" || type[1] == "wav" || type[1] == "avi" || type[1] == "webm") {
                    this.audiovideo.push(attachment);
                } else {
                    this.files.push(attachment);
                }
                this.getResumableURL(input.file, this.attachments[this.attachments.length - 1]);
            }
        },
        getResumableURL(file, attachment) {
            this.isUploadingInProgress = true;
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data)
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.uploading = true;
                this.uploadFileToUpload(resumable_url,file,attachment)
                if (response.data.hasOwnProperty('reason')){
                    attachment.error = "Error Uploading"
                    if (attachment.url == undefined) {
                        this.check_attachments = true
                    } else {
                        this.check_attachments = false
                    }
                }
            })
            .catch(error => {
                console.log(error.data.reason)
            })
        },
        uploadFileToUpload(resumable_url, file, attachment) {
            this.$http.post("https://cloudapis.digicollect.com/external/upload_file", file, {
                    onUploadProgress: function (progressEvent) {
                        let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                        if (progress < 100) {
                            attachment.progress = progress;
                        }
                    }.bind(this)
                })
                .then(() => {
                    attachment.progress = 100;
                    attachment.uploading = false;
                    this.isUploadingInProgress = false;
                    delete attachment['source'];
                })
                .catch(error => {
                    console.log(error.data.reason)
                    this.error = "Error Uploading"
                })
        },
    },
}        



// WEBPACK FOOTER //
// ./src/components/mixins/uploadSalesForecast.js